/**
 * DialogManager - Handles NPC dialog interactions
 * Extracted from NPCInteractionUI.tsx
 */

import { NPC, DialogOption } from '../../../../shared/NPCData';
import { gameLogger } from '../../../../utils/GameLogger';

export interface DialogState {
  currentDialog: string;
  availableOptions: DialogOption[];
}

export class DialogManager {
  private npc: NPC;
  private state: DialogState;
  private onDialogSelect?: (option: DialogOption) => void;
  
  constructor(npc: NPC, onDialogSelect?: (option: DialogOption) => void) {
    this.npc = npc;
    this.onDialogSelect = onDialogSelect;
    this.state = {
      currentDialog: (npc as any).dialogue?.greeting || (npc as any).dialog || `Hello, adventurer! I'm ${npc.name}.`,
      availableOptions: (npc as any).dialogOptions || []
    };
  }
  
  /**
   * Handle dialog option selection
   */
  selectOption(option: DialogOption): void {
    // Update current dialog
    this.state.currentDialog = option.text;
    
    // Execute option action
    if (option.action) {
      if (option.action === 'open_shop') {
        gameLogger.info('npc', 'Opening shop');
      } else if (option.action === 'offer_quest') {
        gameLogger.info('npc', 'Offering quest');
      } else if (option.action === 'heal') {
        gameLogger.info('npc', 'Healing player');
      } else if (option.action === 'teleport') {
        gameLogger.info('npc', 'Teleporting player');
      } else if (option.action === 'bank') {
        gameLogger.info('npc', 'Opening bank');
      }
    }
    
    // Notify callback
    if (this.onDialogSelect) {
      this.onDialogSelect(option);
    }
  }
  
  /**
   * Get current dialog state
   */
  getState(): DialogState {
    return { ...this.state };
  }
  
  /**
   * Update available options
   */
  updateOptions(options: DialogOption[]): void {
    this.state.availableOptions = options;
  }
  
  /**
   * Reset to greeting
   */
  reset(): void {
    this.state = {
      currentDialog: (this.npc as any).dialogue?.greeting || (this.npc as any).dialog || `Hello, adventurer! I'm ${this.npc.name}.`,
      availableOptions: (this.npc as any).dialogOptions || []
    };
  }
}